/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/* global FormValidation, restCollection, autocompleete, schema, lng, Element, RestEdit, snackbar, RestEditBasic, CONTENT, CONTENT_TARGET, Promise */

function RestEditStatic(rest, staticKey) {
  if (!this instanceof RestEditStatic)
    return new RestEditStatic(rest, staticKey);

  var that = this;

  // -- attributes --
  this.node = document.createElement("div");
  this.node.classList.add("mdl-tabs__panel");
  this.node.classList.add("rest-edit");

  this.loadSubject = loadSubject;
  this._staticSchema = restCollection[staticKey].schemaData;
  this.label = rest.schemaData[staticKey].label;
  //this._staticSchema = rest.schemaData[staticKey];
  this.node.id = rest.schemaData[staticKey].label; // set an id for tabs#

  /**
   * @type RestSubject
   */
  this._subject = null;
  this._subjectStatic = null;
  this._tbody = null;

  this.onclose = function () {
    console.warn("onclose() Overwrite this!");
  };
  this.onchange = function () {
    console.warn("onchange() Overwrite this!");
  };

  // -- functions --
  // this.loadSubject = loadSubject;
  // this.destroy = destroy;

  // -- init --
  (function () {
    var basicTable = document.createElement("table");
    basicTable.classList.add("mdl-data-table");
    basicTable.classList.add("mdl-js-data-table");
    basicTable.classList.add("basic");

    that._tbody = document.createElement("tbody");
    basicTable.appendChild(that._tbody);

    for (let key in that._staticSchema) {
      let schemaItem = that._staticSchema[key];
      if (schemaItem.type === "collection") continue;
      if (schemaItem.type === "static") continue;

      var tr = document.createElement("tr");

      var labelTd = document.createElement("td");
      labelTd.classList.add("mdl-data-table__cell--non-numeric");
      var label = document.createElement("label");
      label.textContent = schemaItem.label || key;
      labelTd.appendChild(label);
      tr.appendChild(labelTd);

      var inputTd = document.createElement("td");
      tr.appendChild(inputTd);

      let input = RestEdit.genInput(schemaItem, key, inputTd, that.node);

      if (typeof schemaItem.customEdit === "function") {
        input.addEventListener("focus", function (e) {
          input.disabled = true;
          var customEdit = schemaItem.customEdit(that._subject);
          customEdit.onclose = (data) => {
            input.disabled = false;
            switch (schemaItem.type) {
              case "json":
                input.data = data;
                break;
              default:
                input.value = data;
            }
            return saveButttonClick();
          };
          customEdit.oncancel = () => (input.disabled = false);
        });
      }
      that._tbody.appendChild(tr);
    }

    //buttons
    // that._tbody.insertAdjacentHTML('beforeend', `
    that._tbody.insertAdjacentHTML(
      "beforeend",
      `
            <tr>
                <td colspan="2">
                    <i class="material-icons done">done</i>
                    <button class="delete mdl-button mdl-js-button mdl-button--raised mdl-button--accent">Löschen</button>
                    <input type="submit" class="save mdl-button mdl-js-button mdl-button--raised mdl-button--colored" value="Speichern">
                </td>
            </tr>
        `
    );
    that.node.appendChild(basicTable);

    var doneIcon = that._tbody.querySelector("i.done");
    var saveButton = that._tbody.querySelector("input[type=submit]");
    var deleteButton = that._tbody.querySelector("button.delete");

    deleteButton.addEventListener("click", function (e) {
      e.preventDefault();
      if (!that._subject || !that._subject.data.id) {
        return;
      }

      // not good - but I have no idea how to realize the deletion instead
      var newInstance = restCollection[staticKey].createEmptyInstance();
      newInstance.data[rest.schemaKey] = that._subject.data.id;
      newInstance.objectPath =
        newInstance.objectPath + newInstance.data.partner; // concat id

      newInstance
        .destroy()
        .then((updatedSubject) => {
          if (!updatedSubject) return that.onclose();

          doneIcon.classList.add("visible");
          setTimeout(function () {
            doneIcon.classList.remove("visible");
          }, 1500);

          that.onchange();
          that.loadSubject(updatedSubject);
        })
        .catch((xhr) => {
          that.onchange();

          //deleted hard?
          if (xhr && xhr.status === 404) return that.onclose();
          /*
                    snackbar.show({
                        message: lng.get(xhr.status) || lng.get('unknownError')
                    });
                    */
        });
    });

    function saveButttonClick(e) {
      if (!that._subject || !that._subject.data.id)
        //NEW
        saveSubject(e, true);
      else saveSubject(e, false);
    }

    saveButton.addEventListener("click", (e) => saveButttonClick(e));
    function saveSubject(e, resave) {
      if (e) e.preventDefault();
      if (!that._subject || saveButton.disabled) return;

      saveButton.disabled = true;

      // create a new restSubject
      var newInstance = restCollection[staticKey].createEmptyInstance();
      newInstance.data[rest.schemaKey] = that._subject.data.id;
      //newInstance.data.id = that._subject.data.id;

      // collect Data
      RestEditBasic.collectData(newInstance, that._staticSchema, that.node);

      newInstance
        .save()
        .then(() => that._subject.reload())
        .then(() => {
          that.onchange();
          saveButton.disabled = false;
        })
        .catch((e) => {
          saveButton.disabled = false;
          var msg =
            lng.get(`${rest.schemaKey}_${e.status}`) ||
            lng.get(e.status) ||
            lng.get("unknownError");

          snackbar.show({
            message: msg,
          });
        });
    }
  })();

  /**
   * Draw content of a single collection from current dataset
   * @param {RestSubject} subject
   * @returns {undefined}
   */
  function loadSubject(subject) {
    that._subject = subject;
    that._subjectStatic = that._subject.data[staticKey];
    //remove old
    var rows;
    var staticSchemaKey = that._staticSchema.via || staticKey;
    var collectionRest = restCollection[staticSchemaKey];

    collectionRest
      .find({
        where: JSON.stringify({
          id: that._subject.data.id,
        }),
        populate: "", //pop all
      })
      .then((data) => {
        rows = data;
        insertValues();
      });

    function insertValues() {
      // for (var key in rows) {
      for (var key in collectionRest.schemaData) {
        // skip
        if (typeof key == "undefined" || key == rest.schemaKey) continue;

        // look for input
        var input = that._tbody.querySelector('input[name="' + key + '"]');

        if (!input)
          input = that._tbody.querySelector('textarea[name="' + key + '"]');

        if (!input) {
          console.error("input with name '" + key + "' was not found");
          continue;
        }

        if (key == "mailFields") {
          input.readOnly = true;
        }

        switch (typeof rows[key]) {
          case "number":
          case "string":
            //'remove-icon' is the flag for creating an remove from collection button
            if (rows[key] === "remove-icon") {
              console.error(
                "type 'remove-icon' is not supported in RestEditStatic yet"
              );
            } else {
              input.value = rows[key];
            }
            break;
          // boolean values are only valid with checboxes
          case "boolean":
            if (!input.type == "checkbox") {
              console.error("input with name '" + key + "' is not a checkbox");
              break;
            }
            input.checked = rows[key];
            break;
          case "object":
            var object = rows[key];
            var csvLabel = input.parentNode.querySelector(".csv-name");

            if (csvLabel && object.filename) {
              csvLabel.textContent = object.filename;
            }
          case "undefined":
            break;
          default:
            console.error(
              "type " +
                typeof rows[key] +
                " is not supported in RestEditStatic yet"
            );
            break;
        }
      }
    }
  }
}
Object.defineProperty(RestEditStatic, "collectData", {
  enumerable: false,
  /**
   * Applies data from inputs inside the <i>wrapper</i>.
   * <i>save</i> will not be called here.
   * @param {RestSubject} subject
   * @param {object} schemaData
   * @param {Element} wrapper
   * @returns {undefined}
   */
  value: function (subject, schemaData, wrapper) {
    for (var key in schemaData) {
      var schemaItem = schemaData[key];
      if (schemaItem.type === "collection") continue;
      if (schemaItem.type === "static") continue;

      var input;

      if (schemaItem.type === "area")
        input = wrapper.querySelector("textarea[name=" + key + "]");
      else input = wrapper.querySelector("input[name=" + key + "]");

      if (!input) continue;

      var value = input.value;
      switch (schemaItem.type) {
        case "date":
          console.warn("TODO check date value on client side");
          var fpLocale = {
            weekdays: {
              shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
              longhand: [
                "Sonntag",
                "Montag",
                "Dienstag",
                "Mittwoch",
                "Donnerstag",
                "Freitag",
                "Samstag",
              ],
            },
            months: {
              shorthand: [
                "Jan",
                "Feb",
                "Mär",
                "Apr",
                "Mai",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Okt",
                "Nov",
                "Dez",
              ],
              longhand: [
                "Januar",
                "Februar",
                "März",
                "April",
                "Mai",
                "Juni",
                "Juli",
                "August",
                "September",
                "Oktober",
                "November",
                "Dezember",
              ],
            },
            firstDayOfWeek: 1,
            weekAbbreviation: "KW",
            rangeSeparator: " bis ",
            scrollTitle: "Zum Ändern scrollen",
            toggleTitle: "Zum Umschalten klicken",
          };
          new Flatpickr(input, {
            locale: fpLocale,
          });
          break;
        case "checkbox": //use checked attribute
          value = input.checked;
          break;
        case "password": //do not use empty passwords
          if (value.length === 0) continue;
          break;
        case "select":
          break;
        case "model":
          if (input.data) value = input.data.id;
          else if (input.value) value = input.value.id;
          break;
        case "json":
          try {
            //use this as validator
            JSON.parse(input.data);
            value = input.data;
            //stringify it to have a string after subject parse
            //value = JSON.stringify(value);
          } catch (e) {
            snackbar.show({ message: lng.get("validation_json") });
            value = null;
          }
          break;
        case "file":
          var file = input.files[0];
          value = file ? file : null;
          break;
      }
      subject[input.name] = value;
    }
  },
});
